import { AppConstants } from "@/common";
import type { PublisherAppConfig } from "@/common/types/app-config";
const { shelfKeys }: typeof AppConstants = AppConstants;

const config: PublisherAppConfig = {
    featureGuestModeEnabled: true,
    featureHeaderEnabled: true,
    featureSplashLogoEnabled: true,
    featureLoginLogoEnabled: true,
    authMethod: {
        featureMacAddressLoginEnabled: false,
        featureRefreshTokenLoginEnabled: true
    },
    signInMethod: {
        oktaEnabled: false,
        codeEnabled: true,
        formEnabled: false
    },
    isEnabledServiceLinkHeader: false,
    isTimeFormat12: true,
    linkItems: {
        main: {
            client: ["home", "guide", "myTv", "onDemand", "search", "settings"],
            guest: ["home", "guide", "onDemand", "login", "search", "settings"]
        },
        settings: {
            client: [
                "account",
                "favorites",
                "settingsPlayer",
                "parentControl",
                "language",
                "privacy",
                "about",
                "softwareLicense",
                "clearCache"
                /* "freedomService" */ //TODO: It is temp solution. We wait for opinion of 'Freedom'
            ],
            guest: [
                "account",
                "language",
                "privacy",
                "about",
                "softwareLicense",
                "clearCache"
                /* "freedomService" */ //TODO: It is temp solution. We wait for opinion of 'Freedom'
            ]
        }
    },
    devMode: {
        sections: ["api"]
    },
    mainPage: "home",
    lineViewRows: {
        home: [
            shelfKeys.recentChannelsCards,
            shelfKeys.olympicsCards,
            shelfKeys.moviesCards,
            shelfKeys.sportsCards,
            shelfKeys.kidsCards,
            shelfKeys.newsCards,
            shelfKeys.continueWatchingCards,
            shelfKeys.watchAgainCards
        ],
        vod: [
            shelfKeys.channelCards,
            shelfKeys.newShowsCards,
            shelfKeys.newMoviesCards,
            shelfKeys.recommendedShowsCards,
            shelfKeys.recommendedMoviesCards,
            shelfKeys.tabsGenresCards,
            shelfKeys.genresCards
        ]
    },
    guideConfig: {
        featureChannelLogoOriginalEnabled: false,
        featureRedirectToGuidefromPlayerEnabled: false,
        isDynamicOpacityChannelLogo: true,
        featureBtnWatchEnabled: false,
        featureGuideRestartBtnsEnabled: false,
        featureGuideFilterEnabled: true,
        featureGuideControlsEnabled: false,
        featureGuideDetailPageEnabled: true,
        featureMoveLeftRightEnabled: true,
        featureStartFocusCanvasEnabled: false,
        featurePrevProgramEnabled: true,
        featureScrollbarEnabled: false,
        channelsPageSize: 6,
        featureUpdateViewportChannelsEnabled: true
    },
    playerConfig: {
        topPanel: {
            isEnabledChannelNumber: true,
            isEnabledChannelImage: true,
            isEnabledCallSign: false,
            isEnabledProgramName: false
        },
        controlsPanel: {
            isEnabledProgramName: true,
            isEnableAutoCloseInfoAfterUpdateProgram: false
        }
    },
    orderBy: {
        getVodInternalContent: "name ASC"
    },
    login: {
        welcomeScreenEnabled: false
    },
};

export default defineAppConfig({...config})
